import state from './moduleDestinationWorkState.js'
import mutations from './moduleDestinationWorkMutations.js'
import actions from './moduleDestinationWorkActions.js'
import getters from './moduleDestinationWorkGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}
